import { retornoHashValor } from '../../modulos/cripotografia/hash';
import apiZelo from '../backAxiosVendaToken';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
let retorno;

export const BuscaInscricao = async relative_path => {
    try {
        const resposta = await apiZelo.get(
            `/inscricao/${relative_path}`
        );

        return resposta.data;
    } catch (err) {
        return err.message;
    }
};

export const insereInscricao = async value => {
    await fetch(`${url  }/inscricao`, {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        method: 'POST',
        body: JSON.stringify(
            value
        )
    })
        .then(response => {
            retorno = response;
        })
        .catch(err => {
            retorno = err.message;
        });

    return retorno;
};
